<template>
  <GwMenu>
    <template #opener>
      <div class="mdi mdi-account-circle tpmen_icon icon_btn csst csst_nm">
        <div
          class="csst_content pa-2 text-nowrap"
          style="transform: translate(0, 2.5rem); right: 0rem"
          v-html="$t('tooltips.account')"
        ></div>
      </div>
    </template>
    <template #default="{ methods }">
      <div
        class="gw_menu f-column"
        style="padding: 0.5rem 0"
      >
        <div
          v-for="item in settingsLinks"
          :key="item.pathName"
          :data-tst="`menu_item_${item.pathName}`"
          @click="methods.toggleOpen(false)"
        >
          <router-link
            :to="{ name: item.pathName }"
            @click="
              () => {
                if (item.fn) {
                  item.fn()
                }
              }
            "
          >
            <NavCard
              :item="item"
              :hasSub="false"
              class="navcard_menu navcard_menu-trigger navcard_router-link navcard_appbar"
            />
          </router-link>
        </div>
        <LangMenu
          :isInside="true"
          placement="right-start"
          @click="methods.toggleOpen(false)"
        >
          <template #opener>
            <NavCard
              :item="{ icon: 'mdi-translate' }"
              class="navcard_menu navcard_menu-trigger navcard_router-link navcard_appbar"
            >
              <template #title>
                <div class="f-align-center">
                  {{ $t('langs.lang') }}
                  <i class="mdi mdi-chevron-right text-semi-large ml-auto my-auto" />
                </div>
              </template>
            </NavCard>
          </template>
        </LangMenu>

        <NavCard
          :item="{ icon: 'mdi-logout', title: $t('links.log_out') }"
          class="navcard_menu navcard_menu-trigger navcard_router-link navcard_appbar"
          @click="logout"
        />
      </div>
    </template>
  </GwMenu>
</template>

<script>
import links_mix from '@/mixins/links_mix'
import GwMenu from '@/components/lib/GwMenu'
import LangMenu from '@/components/LangSwitcher/LangMenu'

export default {
  name: 'SettingsMenu',
  components: {
    GwMenu, //
    LangMenu,
  },
  mixins: [links_mix],
  methods: {
    logout() {
      this.$store.dispatch('api_logout')
    },
  },
  computed: {
    settingsLinks() {
      return [
        this.links_all.UserAccount,
        this.links_all.UserSubscription,
        !!this.$store.getters.sol_eliteTierPurchased && this.links_all.UserCredits,
        this.links_all.UserGameSettings,
        this.links_all.UserAppearance,
        this.links_all.UserHotkeys,
      ].filter(Boolean)
    },
  },
}
</script>
